import { Button, Tooltip } from '@usealloy/component-library';
import styled from 'styled-components';

export const StyledSearchTrigger = styled(Button)`
  &&& {
    padding-left: var(--cl-space-2);
    padding-right: var(--cl-space-2);
  }
`;

export const StyledTooltip = styled(Tooltip)`
  text-align: center;
`;
